import jsonApiErrorHandler from '../errors/json-api-error-handler'

const ErrorMessageMap = {
    'arl.credentials.invalid' : 'Invalid user ID or password'
};

export default responseError => {
    return jsonApiErrorHandler(responseError, ErrorMessageMap)
}



// WEBPACK FOOTER //
// ./src/app/helpers/obtainResponseErrorMessage.js